/**
 * Utility class for managing OWA (Online Web Analytics) parameters.
 */
class OwaParamsHelper {
    /**
     * Updates window.owaParams with new parameters and event ID.
     *
     * @param {Object|null} optimusParams - Parameters from Optimus API (optional)
     * @param {string|null} eventId - Event ID to include (optional)
     */
    static updateWindowOwaParams(optimusParams = null, eventId = null) {
        const params = optimusParams ? {...optimusParams} : {
            page_type: window.tracking?.owaPageType ?? undefined,
            uid: window.tracking?.uid ?? undefined,
            device_type: window.tracking?.deviceType ?? 'd',
            eventId: window.tracking?.pageViewId
        };

        window.owaParams = params;
        if (eventId) {
            window.owaParams.eventId = eventId;
        }
    }

    /**
     * Gets the current OWA parameters from window.
     *
     * @returns {Object|null} Current OWA parameters or null
     */
    static getWindowOwaParams() {
        return window.owaParams ?? null;
    }
}

export default OwaParamsHelper;
